import { motion } from "framer-motion";
import { FaWhatsapp, FaFileInvoice, FaUsersCog } from "react-icons/fa";

export default function TravelNexBanner({
  websiteUrl = "https://www.travelnextech.com/",
}) {
  return (
    <section className="relative overflow-hidden mb-10">
      <div className="container relative max-w-8xl mx-auto px-4 sm:px-0">
        <motion.div
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7 }}
          viewport={{ once: true }}
          className="flex flex-col items-center bg-gradient-to-br from-indigo-900 via-purple-900 to-pink-800 justify-between gap-10 rounded-3xl border border-white/20 p-8 backdrop-blur-md lg:flex-row lg:px-12"
        >
          {/* Left content */}
          <div className="max-w-3xl text-white">
            <span className="inline-block rounded-full bg-white/15 py-2 text-sm font-semibold uppercase tracking-wider">
              Travel Agency Software
            </span>

            <h2 className="mt-5 text-3xl font-bold leading-tight md:text-5xl">
              CRM + Invoice + WhatsApp <br />
              <span className="text-pink-300">All in One Platform</span>
            </h2>

            <p className="mt-4 text-lg text-white/90">
              Manage inquiries, create professional invoices, and chat with
              customers instantly — built for travel agencies.
            </p>

            <div className="mt-6 flex flex-wrap gap-5 text-white/90">
              <div className="flex items-center gap-2">
                <FaUsersCog />
                <span>Customer Management</span>
              </div>
              <div className="flex items-center gap-2">
                <FaFileInvoice />
                <span>Invoicing</span>
              </div>
              <div className="flex items-center gap-2">
                <FaWhatsapp />
                <span>WhatsApp Integration</span>
              </div>
            </div>
          </div>

          {/* CTA Button */}
          <motion.a
            whileHover={{ scale: 1.06 }}
            whileTap={{ scale: 0.96 }}
            href={websiteUrl}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-2 rounded-full bg-white px-8 py-4 text-lg font-semibold text-indigo-900 shadow-2xl transition-colors hover:bg-gray-100 focus:outline-none focus:ring-4 focus:ring-white/50"
          >
            Visit Website →
          </motion.a>
        </motion.div>
      </div>
    </section>
  );
}